import React from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { BsSave2Fill } from "react-icons/bs";
import { MdRefresh } from "react-icons/md";

const ApiKeySection = ({
  isVisible,
  apiKey,
  handleToggleVisibility,
  setApiKey,
  handleSaveApiKey,
  displayValue,
  showDemoWarning,
  handleRefresh,
  isUpdating,

  theme,
}) => {
  return (
    <div className="mb-3 rounded-2xl border border-indigo-200 bg-white/70 p-3 backdrop-blur">
      <h3 className="mb-2 text-sm font-semibold text-slate-900">API Key</h3>

      <div className="grid grid-cols-[1fr_max-content_max-content] gap-2 items-center">
        <div className="relative">
          <input
            type={isVisible ? "text" : "password"}
            value={isVisible ? apiKey : displayValue()}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="Enter API Key"
            className={`w-full rounded-xl border border-indigo-200 bg-white/90 p-2 text-xs text-slate-700 transition duration-200 focus:outline-none focus:ring-2 ${theme.inputFocusRing}`}
          />
          <button
            type="button"
            onClick={handleToggleVisibility}
            className="absolute right-2 top-1/2 -translate-y-1/2 transform text-slate-500 hover:text-slate-700"
          >
            {isVisible ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
          </button>
        </div>

        <button
          type="button"
          onClick={handleSaveApiKey}
          className="inline-flex w-full items-center gap-1 rounded-xl bg-gradient-to-r from-indigo-600 to-violet-600 px-3 py-2 text-xs font-medium text-white transition duration-300 hover:opacity-95"
        >
          <BsSave2Fill size={12} className="inline mr-1" />
          Save
        </button>

        <button
          type="button"
          onClick={handleRefresh}
          className="h-full rounded-xl border border-indigo-200 bg-white px-2 text-slate-600 hover:bg-indigo-50"
          title="Refresh profile"
          aria-label="Refresh profile"
        >
          <MdRefresh className={isUpdating ? "animate-spin" : ""} size={18} />
        </button>
      </div>

      {showDemoWarning && (
        <p className="mt-2 text-xs text-rose-600">
          This is a demo API. You can only send 100 messages for the next 3
          days.
        </p>
      )}

      <p className="mt-3 text-xs text-slate-500">
        If you don't have an API key, visit{" "}
        <a
          href="https://app.smartitbox.in/apiKey/list"
          target="_blank"
          rel="noopener noreferrer"
          className="text-indigo-600 underline hover:text-indigo-800"
        >
          this link
        </a>{" "}
        to generate one.
      </p>
    </div>
  );
};

export default ApiKeySection;
